import styled from "styled-components"
import { device } from "breakpoints"
import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "helpers/getSolidColor"
import { Button } from "components/Button"
import { MainColumn } from "components/MainColumn"
import {
  InfoWrapper,
  ImageWrapper,
  Tag,
  Excerpt,
  Title,
} from "components/Teaser/style"
import BigTeaser from "../BigTeaser/BigTeaser"

export const StoriesTeaser = styled(BigTeaser)`
  width: 100% !important;
  margin-bottom: -4px !important;

  @media ${device.tablet} {
    margin-bottom: 52px !important;
  }
  @media ${device.large} {
    margin-bottom: 82px !important;
  }

  ${ImageWrapper} {
    margin-bottom: 21px;
    @media ${device.tablet} {
      margin-bottom: 0;
    }
  }
  ${InfoWrapper} {
    @media ${device.tablet} {
      padding: 25px 25px;
    }
    @media ${device.desktop} {
      padding: 20px 50px;
      padding-right: 17px;
    }
    @media ${device.large} {
      padding: 20px 80px;
      padding-right: 17px;
    }
  }

  ${Title} {
    font-size: 34px;
    color: #000000;
    letter-spacing: -0.47px;
    line-height: 36px;

    @media ${device.desktop} {
      font-size: 48px;
      letter-spacing: -0.5px;
      line-height: 42px;
    }
  }
  ${Excerpt} {
    @media ${device.large} {
      padding-right: 80px;
    }
  }

  ${Tag} {
    font-size: 10px;
    letter-spacing: 4.29px;
    line-height: 18px;

    @media ${device.large} {
      font-size: 12px;
      letter-spacing: 5.14px;
      line-height: 18px;
      padding-left: 2px;
      margin-bottom: 20px;
    }
  }
`

export const StoriesTeaserAndCTAContainer = styled(MainColumn)`
  position: relative;

  margin: ${props => `${props.theme.componentMargin.mobile}px auto`};
  @media ${device.desktop} {
    margin: ${props => `${props.theme.componentMargin.desktop}px auto`};
  }

  @media ${device.large} {
    margin: ${props => `${props.theme.componentMargin.large}px auto`};
  }
`
export const ButtonContainer = styled.div`
  margin-top: 40px;
  @media ${device.tablet} {
    margin-top: 0px;

    width: 100%;
    display: flex;
    justify-content: center;
  }
`
export const StoriesCTA = styled(Button)`
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: -0.11px;
  text-align: center;
  line-height: 24px;
  background: ${props => getGradient(props.theme.site)};
  border-radius: 25px;
  padding: 0 28px;
  /* margin-bottom: 52px; */
  max-width: 145px;
  position: relative;

  :hover {
    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      border-radius: 25px;
      background: ${props => getSolidColor(props.theme.site)};
    }
  }

  @media ${device.tablet} {
    padding: 0 25px;
  }

  @media ${device.desktop} {
    font-size: 16px;
    max-width: 188px;
    letter-spacing: -0.16px;
    padding: 0 44px;
  }
`
